import { ContextStore } from '../../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../../react-core/Async/Promise';
import { ReportInfo } from '../../../../Models/Models/Reports/ReportInfo';
import { AdviserChargeReport } from '../../../../Models/Models/AdviserCharges/AdviserChargeReport';

declare var IS_RUNNING_IN_APP_POOL;

export class AdviserChargeReportClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(report: AdviserChargeReport): Promise<ReportInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/BusinessManagement/AdviserCharge/AdviserChargeReport/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { report: report }

    return AjaxWrapper.post<ReportInfo, any>(url, data);
  }
}

